import {
  GET_PLAYER_INFO,
  START_COLLECT_DEPOSIT_MONEY,
  FINISH_COLLECT_DEPOSIT_MONEY,
  GET_DEPOSIT_RECORDS,
  PRINT_DEPOSIT_TICKET_BY_ID,
  GET_WITHDRAWAL_REQUESTS,
  VALIDATE_WITHDRAWAL_PIN,
  PAY_WITHDRAWAL_REQUEST,
} from "./actionTypes";

export const GetPlayerInfo = (payload) => ({
  type: GET_PLAYER_INFO,
  payload,
});

export const StartCollectDepositMoney = (payload) => ({
  type: START_COLLECT_DEPOSIT_MONEY,
  payload,
});

export const FinishCollectDepositMoney = (payload) => ({
  type: FINISH_COLLECT_DEPOSIT_MONEY,
  payload,
});

export const GetDepositRecords = (payload) => ({
  type: GET_DEPOSIT_RECORDS,
  payload,
});

export const PrintDepositTicketById = (payload) => ({
  type: PRINT_DEPOSIT_TICKET_BY_ID,
  payload,
});

export const GetWithdrawalRequests = (payload) => ({
  type: GET_WITHDRAWAL_REQUESTS,
  payload,
});

export const ValidateWithdrawalPin = (payload) => ({
  type: VALIDATE_WITHDRAWAL_PIN,
  payload,
});

export const PayWithdrawalRequest = (payload) => ({
  type: PAY_WITHDRAWAL_REQUEST,
  payload,
});
